import React from "react";

import { useTranslation } from "react-i18next";

import Button from "@/components/Button";

interface ErrorViewProps {
  formError: {
    title: string;
    message: string;
  };
  clearingCache: boolean;
  onClearCache: () => void;
}

const ErrorView: React.FC<ErrorViewProps> = ({
  formError,
  clearingCache,
  onClearCache,
}) => {
  const { t } = useTranslation();

  return (
    <div
      id="error-message"
      className="w-full pt-24 pb-24 border-lightgrey border-t-2"
    >
      <h4 className="text-lg font-bold text-red">{t("error")}</h4>
      <p className="mt-6 text-sm">{formError.title}</p>
      <code
        className="block w-full border-2 rounded-md p-2 mt-6 text-sm"
        dangerouslySetInnerHTML={{ __html: formError.message }}
      />

      <Button onClick={onClearCache} loading={clearingCache} className="mt-6">
        {t("clearCache")}
      </Button>
    </div>
  );
};

export default ErrorView;
